import { render, staticRenderFns } from "./MessagesWidget.vue?vue&type=template&id=d6ff6c10&scoped=true&"
import script from "./MessagesWidget.vue?vue&type=script&lang=js&"
export * from "./MessagesWidget.vue?vue&type=script&lang=js&"
import style0 from "./MessagesWidget.vue?vue&type=style&index=0&id=d6ff6c10&prod&scoped=true&lang=css&"
import style1 from "./MessagesWidget.vue?vue&type=style&index=1&id=d6ff6c10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ff6c10",
  null
  
)

export default component.exports